export enum OrganizationSpecificFilterAPIKeys {
  organizationSpecificFields = 'organizationSpecificFields',
  rightPossession = 'right_possession',
}
